import { Recap } from '@/components/Recap'
import { FormSection } from '@/containers/forms/FormSection'
import { usePartner } from '@/context/PartnerContext'
import { useSidebar } from '@/context/SidebarContext'

import { PageSection } from '@/components/PageSection'
import { useMeetingRecord } from '@/context/MeetingRecordProvider'
import type { PageSection as Section } from '@/layouts/components/Sidebar'
import { Grid } from '@chakra-ui/react'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import React, { useEffect } from 'react'
import { CustomWaypoint } from '../../../../components/CustomWaypoint'
import { Loading } from '../../../../components/Loading'
import { useSelectedQuote } from '../../../../context/SelectedQuoteContext'
import CommonMeetingRecordForm from '../../vehicle/Step4/forms/CommonMeetingRecordForm'
import { CreateContractForm } from '../../vehicle/Step4/forms/CreateContractForm'
import EssoxMeetingRecordForm from '../../vehicle/Step4/forms/EssoxMeetingRecordForm'
import KapitolCreateContractForm from '../../vehicle/Step4/forms/KapitolCreateContractForm'
import KapitolMeetingRecordForm from '../../vehicle/Step4/forms/KapitolMeetingRecordForm'
import { QuoteInformation } from '../../vehicle/StepComplete/forms/QuoteInformation'
import type { Step4FormValues } from '../Step4/Step4'

export const StepComplete = () => {
  const { offer, isLoading: isLoadingOffer } = useSelectedQuote()
  const { setPageSections, pageSections } = useSidebar()
  const { currentPartner } = usePartner()

  const { refetch: refetchMR, meetingRecord } = useMeetingRecord()
  const methods = useForm<Step4FormValues>({
    defaultValues: { meetingRecord },
  })

  useEffect(() => {
    refetchMR().then((data) => methods.reset({ meetingRecord: data.data }))
  }, [])  // registrace sekcí

  useEffect(() => {
    if (!offer) return

    const array: Section[] = []
    let i = 1

    array.push(
      {
        id: 'recapitulation',
        sectionTitle: 'Rekapitulace pojištění',
        index: i++,
        children: !offer || isLoadingOffer
          ? <Loading large={true} />
          : (
            <CustomWaypoint sectionId="recapitulation" cardProps={{ sx: { gap: 16, pb: 16 } }}>
              <Recap id="recapitulation" sx={{ gap: 16, pb: 16 }}>
                <QuoteInformation offer={offer} />
              </Recap>
            </CustomWaypoint>
          )
      }
    )

    let partnerMeetingRecordForm = null
    let partnerArrangeContractForm = null
    switch (currentPartner?.partner) {
      case 'Kapitol':
        partnerMeetingRecordForm = <KapitolMeetingRecordForm />
        partnerArrangeContractForm = <KapitolCreateContractForm />
        break
      case 'Essox':
      case 'AutoEsa':
      case 'DirectAuto':
        partnerMeetingRecordForm = <EssoxMeetingRecordForm />
        break
      default:
        partnerMeetingRecordForm = <CommonMeetingRecordForm />
        partnerArrangeContractForm = <CreateContractForm />
        break
    }

    array.push({
      id: 'meetingRecord',
      sectionTitle: 'Záznam z jednání',
      index: i,
      children: (
        <CustomWaypoint sectionId="recapitulation">
          <PageSection id={'meetingRecord'}>
            <FormSection
              number={i++}
              sectionTitle={'Záznam z jednání'}
              wide={false}
            >
              {partnerMeetingRecordForm}
            </FormSection>
          </PageSection>
        </CustomWaypoint>
      ),
    })

    // sekce Sjednání
    array.push({
      id: 'contract',
      sectionTitle: 'Sjednání',
      index: i,
      useFormSection: true,
      children: (
        <CustomWaypoint sectionId="contract">
          <PageSection id={'contract'}>
            <FormSection number={i++} sectionTitle={'Sjednání'} wide={false}>
              <Grid rowGap={20}>{partnerArrangeContractForm}</Grid>
            </FormSection>
          </PageSection>
        </CustomWaypoint>
      ),
    })

    setPageSections(array)
  }, [offer, isLoadingOffer])


  return (
    <FormProvider {...methods}>
      <Grid sx={{ gap: 8 }}>
        {pageSections && pageSections.map(x => (
          <React.Fragment key={x.id}>
            {x.children}
          </React.Fragment>
        ))}
      </Grid >
    </FormProvider>
  )
}